import type { Cache, SWRConfiguration } from "swr";

import { swrGCMiddleware } from "lib/swrMiddlewares";
import { FREQUENT_UPDATE_INTERVAL } from "lib/timeConstants";

export let swrCache: Cache = new Map();

// Allow disabling global polling in dev to reduce request volume during bring-up
const GLOBAL_POLLING_DISABLED = import.meta.env.VITE_DISABLE_POLLING === "true";
const globalRefreshInterval = GLOBAL_POLLING_DISABLED ? 0 : FREQUENT_UPDATE_INTERVAL;

export const SWRConfigProp: SWRConfiguration = {
  refreshInterval: globalRefreshInterval,
  dedupingInterval: 10_000,
  refreshWhenHidden: false,
  refreshWhenOffline: false,
  // @ts-ignore
  use: [swrGCMiddleware],
  provider: () => {
    swrCache = new Map();
    return swrCache;
  },
};
